export const BookingsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        d="M3.5 8.61111V5.41667C3.5 4.72631 4.05964 4.16667 4.75 4.16667H15.25C15.9404 4.16667 16.5 4.72631 16.5 5.41667V8.61111M3.5 8.61111V16.25C3.5 16.9404 4.05964 17.5 4.75 17.5H15.25C15.9404 17.5 16.5 16.9404 16.5 16.25V8.61111M3.5 8.61111H16.5M7.29167 2.5V5.83333M12.7083 2.5V5.83333M7.5 13L8.9293 14.4293C8.96835 14.4683 9.03166 14.4684 9.07071 14.4293L12.7083 10.7928"
        stroke="currentColor"
        stroke-linecap="round"
      />
    </svg>
  );
};
